import random from 'lodash/random';
import { useMemo } from 'react';
import colors from '~/theme/colors.module.scss';
import { Category } from '~/types/category';
import { getContrastTextColor } from '~/utils/styles';

export interface CategoryColorConfig {
  color: string;
  text: string;
}

const DarkTextColor = colors.colorGrey800;
const LightTextColor = 'white';

export const PredefinedCategoryColorsConfig: CategoryColorConfig[] = [
  {
    color: colors.colorViolet200,
    text: DarkTextColor,
  },
  {
    color: colors.colorBerry200,
    text: DarkTextColor,
  },
  {
    color: colors.colorPink300,
    text: DarkTextColor,
  },
  {
    color: colors.colorLobster300,
    text: DarkTextColor,
  },
  {
    color: colors.colorOrange300,
    text: DarkTextColor,
  },
  {
    color: colors.colorLemon200,
    text: DarkTextColor,
  },
  {
    color: colors.colorTeal200,
    text: DarkTextColor,
  },
  {
    color: colors.colorGreen200,
    text: DarkTextColor,
  },
  {
    color: colors.colorForest200,
    text: DarkTextColor,
  },
  {
    color: colors.colorSea200,
    text: DarkTextColor,
  },
  {
    color: colors.colorViolet400,
    text: DarkTextColor,
  },
  {
    color: colors.colorBerry400,
    text: DarkTextColor,
  },
  {
    color: colors.colorPink500,
    text: DarkTextColor,
  },
  {
    color: colors.colorLobster500,
    text: DarkTextColor,
  },
  {
    color: colors.colorOrange500,
    text: DarkTextColor,
  },
  {
    color: colors.colorLemon500,
    text: DarkTextColor,
  },
  {
    color: colors.colorTeal500,
    text: DarkTextColor,
  },
  {
    color: colors.colorGreen500,
    text: DarkTextColor,
  },
  {
    color: colors.colorForest500,
    text: DarkTextColor,
  },
  {
    color: colors.colorSea400,
    text: DarkTextColor,
  },
  {
    color: colors.colorViolet600,
    text: LightTextColor,
  },
  {
    color: colors.colorBerry800,
    text: LightTextColor,
  },
  {
    color: colors.colorPink700,
    text: LightTextColor,
  },
  {
    color: colors.colorLobster900,
    text: LightTextColor,
  },
  {
    color: colors.colorOrange800,
    text: LightTextColor,
  },
  {
    color: colors.colorLemon700,
    text: LightTextColor,
  },
  {
    color: colors.colorTeal800,
    text: LightTextColor,
  },
  {
    color: colors.colorGreen800,
    text: LightTextColor,
  },
  {
    color: colors.colorForest800,
    text: LightTextColor,
  },
  {
    color: colors.colorSea800,
    text: LightTextColor,
  },
];

const PredefinedColorsMapConfig = PredefinedCategoryColorsConfig.reduce(
  (acc: Record<string, CategoryColorConfig>, conf: CategoryColorConfig) => {
    acc[conf.color] = conf;
    return acc;
  },
  {},
);

export const UncategorisedConfig: CategoryColorConfig = {
  color: '#e5e4e3',
  text: getContrastTextColor('#e5e4e3'),
};

const getCustomColorConfig = (color: string): CategoryColorConfig => ({
  color,
  text: getContrastTextColor(color),
});

export const getCategoryColor = (categoryColor?: string) => {
  if (!categoryColor) return UncategorisedConfig;
  return categoryColor in PredefinedColorsMapConfig
    ? PredefinedColorsMapConfig[categoryColor]!
    : getCustomColorConfig(categoryColor);
};

const useCategoryColor = (category: Category | { color: string } | null) => {
  const categoryColor = category?.color;
  const colorConfig = useMemo(() => getCategoryColor(categoryColor), [categoryColor]);

  return colorConfig;
};

export const getRandomCategoryColorConfig = () => {
  const randomIndex = random(0, PredefinedCategoryColorsConfig.length - 1);
  return PredefinedCategoryColorsConfig[randomIndex]!;
};

export default useCategoryColor;
